import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  makeStyles,
} from '@material-ui/core';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PaymentIcon from '@mui/icons-material/Payment';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: 56,
    color: theme.palette.warning.main,
  },
  message: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
    marginBottom: theme.spacing(1),
  },
  highlight: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  dateText: {
    fontSize: '1rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  button: {
    borderRadius: 12,
  },
}));

/**
 * Modal de aviso de trial acabando.
 *
 * Props (novo backend):
 *   trial: { active, daysLeft, expiresAt }  — vem de user.trial
 *
 * Prop legado mantido para compatibilidade durante migração:
 *   dueDate: string ISO                      — vem de user.company.dueDate
 */
const TrialEndingModal = ({ open, onClose, trial, dueDate }) => {
  const classes = useStyles();
  const history = useHistory();

  // Usa user.trial quando disponível; fallback para dueDate legado
  const daysLeft = trial?.daysLeft ?? null;
  const expiresAt = trial?.expiresAt ?? dueDate ?? null;
  const formattedDate = expiresAt ? moment(expiresAt).format('DD/MM/YYYY') : '';

  const daysLabel =
    daysLeft === null
      ? 'em breve'
      : daysLeft <= 1
        ? 'hoje'
        : `em ${daysLeft} ${daysLeft === 1 ? 'dia' : 'dias'}`;

  const handleGoToPlans = () => {
    onClose();
    history.push('/subscription/plans');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h6" component="div" align="center" style={{ fontWeight: 600 }}>
          Período de teste acabando
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box className={classes.iconWrapper}>
          <ScheduleIcon className={classes.icon} />
        </Box>
        <Typography className={classes.message}>
          Seu período de teste encerra <span className={classes.highlight}>{daysLabel}</span>.
        </Typography>
        {formattedDate && (
          <Typography className={classes.dateText} align="center">
            Vencimento: {formattedDate}
          </Typography>
        )}
        <Typography className={classes.message}>
          Escolha um plano para continuar usando o sistema sem interrupções.
        </Typography>
      </DialogContent>
      <DialogActions
        style={{ justifyContent: 'center', paddingBottom: 24, flexWrap: 'wrap', gap: 8 }}
      >
        <Button variant="outlined" onClick={onClose} className={classes.button}>
          Lembrar depois
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoToPlans}
          className={classes.button}
          startIcon={<PaymentIcon fontSize="small" />}
        >
          Ver planos
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrialEndingModal;
